"use client"

import { SnackbarProvider } from "notistack"
import NiceModal from "@ebay/nice-modal-react"
import type { PropsWithChildren } from "react"

import I18Provider from "@/molecules/i18_provider"
import AppHeader from "@/organism/app_header"
import { init as initAxios } from "@/molecules/axios"
import FavIcon from "@/molecules/fav_icon"
import useSessionExpiryGuard from "@/hooks/use_session_expiry_guard"
import DataLoader from "@/components/data_loader"
import Theme from "@/molecules/theme"
import ErrorBoundary from "@/utils/error_boundary"
import { initAwsRum, SetupRumTestError } from "@/utils/aws_rum"
import GoogleAnalyticsConfig from "@/components/google_analytics_config"

const App = ({ children }: PropsWithChildren) => {
  useSessionExpiryGuard()
  initAxios()
  initAwsRum()

  return (
    <I18Provider>
      <FavIcon />
      <Theme>
        <ErrorBoundary>
          <SetupRumTestError />
          <AppHeader />
          <SnackbarProvider
            anchorOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
          />
          <DataLoader>
            <GoogleAnalyticsConfig />
            <NiceModal.Provider>{children}</NiceModal.Provider>
          </DataLoader>
        </ErrorBoundary>
      </Theme>
    </I18Provider>
  )
}

export default App
